import { Request } from "@/datastructures/ViewModelFormTypes";

export class VerifySubjectViewModel {
  // State (Visibility)
  public errorTextVisible = false;
  public successTextVisible = false;

  // Requests
  public verifySubjectRequest: Request = { loading: false, error: "" };

  // Texts
  public title = "";
  public waitText = "";
  public successText = "";
  public errorText = "";
}
